import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { jiraReducers, jiraWatchers } from './jira';
import { slackReducers, slackWatchers } from './slack/index';

export const integrationReducers = combineReducers({
	jira: jiraReducers,
	slack: slackReducers
});

export const integrationWatchers = combineAllWatchers([
	jiraWatchers,
	slackWatchers
]);
